import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const FirmaServiceConfig = {
  name: "Firma",
  annotations: []
} as ServiceConfig;